import React, { useCallback } from 'react';
import { TablePagination } from '@material-ui/core';

type Props = {
  count: number;
  page: number;
  pageSize: number;
  pageSizeOptions: number[];
  onPageChange: (value: number) => void;
  onPageSizeChange: (value: number) => void;
};

const Pagination = ({
  count,
  page,
  pageSize,
  pageSizeOptions,
  onPageChange,
  onPageSizeChange,
}: Props) => {
  const changePageHandler = useCallback((_: unknown, newPage: number) => {
    onPageChange(newPage);
  }, [onPageChange]);

  const changeRowsPerPageHandler = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    onPageSizeChange(Number(e.target.value));
  }, [onPageSizeChange]);

  return (
    <TablePagination
      rowsPerPageOptions={pageSizeOptions}
      component="div"

      count={count}
      rowsPerPage={pageSize}
      page={page}
      onChangePage={changePageHandler}
      onChangeRowsPerPage={changeRowsPerPageHandler}
    />
  );
};

export default Pagination;
